const SurveyLogin = () => {
  return (
    <div style={{ fontSize: '1.2rem', textAlign: 'center' }}>
      <div>
        Sign in to complete the survey.
        <br />
        <br />
      </div>
      <div style={{ fontSize: '0.9rem' }}>
        Please log in with your organization's <br />
        credential to verify access. <br />
        All responses are completely anonymous.
      </div>
    </div>
  );
};

export default SurveyLogin;
